import React from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    backgroundColor: "#eee",
    flex: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
  },
}));

const TicketHeader = ({ loading, children }) => {
  const history = useHistory();
  const handleBack = () => {
    history.push("/tickets");
  };

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <div className="chat-header d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
          <button
            className="btn btn-white btn-shadow btn-icon waves-effect d-lg-none me-2"
            onClick={handleBack}
          >
            <i className="fi fi-rr-arrow-small-left"></i>
          </button>
          {children}
        </div>
      )}
    </>
  );
};

export default TicketHeader;
